import { useNavigate, useLocation } from "react-router-dom";
import Button from "../../Button";
import { HeaderContainer } from "./styles";
import { useAuth } from "../../../contexts/AuthContext";
import VeloprimeLogo from "../../../assets/veloprime/logo-veloprime-horizontal-white.png";

export const Header = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <HeaderContainer>
    <a
          href={"https://veloprime.com.br/"}
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="fixed"
                alt={"VeloPrime logo"}
            src={VeloprimeLogo}
            style={{ height: "35px" }}
          />
        </a>
      {!user.user && !pathname.includes("/p/authorize-accountant") && (
        <div className="buttons">
          <Button
            type="text"
            size="middle"
            onClick={() => navigate("/p/login")}

          >
            ENTRAR
          </Button>
          {/* <Button
            type="primary"
            size="middle"
            onClick={() => navigate("/p/cadastrar")}
          >
            COMEÇAR
          </Button> */}
        </div>
      )}
    </HeaderContainer>
  );
};
